import { addNewRelicPageAction } from '@ddc/new-relic';

/*
 * Using a wrapper function around addNewRelicPageAction incase
 * we need to alter/append attributes after they are sent to this function
 */
export const reportToNewRelic = (actionName, attributes = {}) => {
	addNewRelicPageAction(actionName, attributes);
};
